/* src/app/layouts/authenticated/left-side-navigation-component/left-side-navigation.component.css */
.mat-mdc-badge-content {
  z-index: 1000;
}
mat-list-item {
  overflow: visible;
  display: block;
  text-align: center;
  max-width: 100%;
}
/*# sourceMappingURL=left-side-navigation.component-C75ZPKRR.css.map */
